import type { ArrowShape as ArrowShapeType } from '@/features/comment-on-file';
import { strokeWidthFor } from './strokeWidths';

interface Props {
  shape: ArrowShapeType;
  color: string;
  markerId: string;
  focused?: boolean;
  halo?: boolean;
}

export function ArrowShape({ shape, color, markerId, focused, halo }: Props) {
  const { start, end } = shape;
  const strokeWidth = strokeWidthFor('arrow', { focused, halo });
  return (
    <line
      x1={start.x}
      y1={start.y}
      x2={end.x}
      y2={end.y}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
      markerEnd={`url(#${markerId})`}
    />
  );
}

interface ArrowMarkerProps {
  id: string;
  color: string;
}

export function ArrowMarker({ id, color }: ArrowMarkerProps) {
  return (
    <marker
      id={id}
      viewBox="0 0 10 10"
      refX="8"
      refY="5"
      markerWidth="6"
      markerHeight="6"
      orient="auto-start-reverse"
      markerUnits="strokeWidth"
    >
      <path d="M 0 0 L 10 5 L 0 10 z" fill={color} />
    </marker>
  );
}
